import { ROUTES } from '@/components/Shared/routes/routes';

export const pageTitles = {
  [ROUTES.home]: 'Главная',

  [ROUTES.autoCredit]: 'Автокредитование',
  [ROUTES.autoCreditCreate]: 'Новая заявка',

  [ROUTES.insurances]: 'Страхование',
  [ROUTES.insurancesCreate]: 'Новая заявка',
  [ROUTES.insurancesRequest()]: 'Заявка',

  [ROUTES.reports]: 'Отчеты',

  [ROUTES.clients]: 'Клиенты',
  [ROUTES.client()]: 'Клиент',
  [ROUTES.leads]: 'Лиды',
  [ROUTES.leadsUpdate()]: 'Редактирование лида'
};
